/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const ZodiacVirgo = createLucideIcon("zodiac-virgo", [
  ["path", { d: "M11 5.5a1 1 0 0 1 5 0V16a5 5 0 0 0 5 5", key: "1szkuh" }],
  ["path", { d: "M16 11.5a1 1 0 0 1 5 0V16a5 5 0 0 1-5 5", key: "pyq0k2" }],
  ["path", { d: "M6 19V6a3 3 0 0 0-3-3h0", key: "pvee4g" }],
  ["path", { d: "M6 5.5a1 1 0 0 1 5 0V19", key: "vncctg" }]
]);

export { ZodiacVirgo as default };
//# sourceMappingURL=zodiac-virgo.js.map
